import { useQuery } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

type SurveyInvitation = {
	id: string;
	surveyName: string;
	completed: boolean;
	createdAt: string;
	createdBy: string;
	expiresAt: string;
};

export const useGetSurveyInvitations = (
	args: {
		projectId: number;
		entryId: string;
		seriesName: string;
	},
	options?: {
		enabled?: boolean;
	}
) => {
	return useQuery({
		queryKey: ['surveyInvitations', args.projectId, args.entryId, args.seriesName],
		queryFn: () =>
			makeRequest<{
				surveyInvitations: SurveyInvitation[];
			}>({
				method: 'getSurveyInvitations',
				service: 'cde',
				data: {
					projectId: args.projectId,
					entryId: args.entryId,
					seriesName: args.seriesName
				}
			}),
		enabled: options?.enabled ?? true
	});
};
